import React from "react";
import { motion } from "framer-motion";
import Slider from "react-slick";

// Local images
import heroImg from "../../assets/9.jpg";
import contentImg from "../../assets/resi.jpg";

// Import 9 project images
import imgg1 from '../../assets/r111.webp';
import imgg2 from '../../assets/r22.webp';
import imgg3 from '../../assets/r33.webp';
import imgg4 from '../../assets/r44.webp';
import imgg5 from '../../assets/r55.webp';
import imgg6 from '../../assets/r66.jpg';
import imgg7 from '../../assets/r77.webp';
import imgg8 from '../../assets/r88.webp';
import imgg9 from '../../assets/r99.webp';

// Replace online placeholder images with local ones
const projectImages = [imgg1, imgg2, imgg3, imgg4, imgg5, imgg6, imgg7, imgg8, imgg9];

const ResidentialAppartment = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="w-full">
      {/* Hero Section */}
      <div
        className="w-full h-[430px] relative flex items-center justify-start px-6 md:px-12"
        style={{
          backgroundImage: `url(${heroImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="bg-black/40 p-4 md:p-6 rounded-md">
          <p className="text-white text-sm md:text-base mb-1 cursor-pointer">Home</p>
          <h1 className="text-white text-2xl md:text-4xl font-bold">
            Residential Appartment
          </h1>
        </div>
      </div>

      {/* Content Section */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 flex flex-col md:flex-row items-center gap-10">
        <div className="md:w-1/2 space-y-6">
          <p className="text-gray-700 text-lg leading-relaxed text-justify">
            In recent years, low-rise apartments have increasingly incorporated lift facilities, providing essential convenience to residents. These lifts are not just a practical addition, but also a valuable feature that enhances the property’s market value. For builders and property owners, installing a lift becomes a unique selling point, making the property more desirable. Furthermore, to maximize space efficiency, low-rise buildings can opt for lift models that are compact and space-saving.
          </p>
          <p className="text-gray-700 text-lg leading-relaxed text-justify">
            Architects, builders, and flat associations are encouraged to contact us for lift installation or modernization services. Reach out today to discuss the ideal lift solution for your residential space!
          </p>
        </div>

        <motion.div
          className="md:w-1/2 w-full"
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          <img
            src={contentImg}
            alt="Residential Apartment Lift"
            className="w-full h-[350px] md:h-[400px] object-cover rounded-2xl shadow-2xl"
          />
        </motion.div>
      </div>

      {/* Projects Section */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-10">
          SOME PROJECTS
        </h2>

        <Slider {...sliderSettings}>
          {projectImages.map((img, idx) => (
            <div key={idx} className="px-2">
              <img
                src={img}
                alt={`Project ${idx + 1}`}
                className="w-full h-64 md:h-72 object-cover rounded-2xl shadow-lg"
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default ResidentialAppartment;
